"use strict";
var Request = (function () {
    function Request() {
    }
    return Request;
}());
exports.Request = Request;



/*****************
 ** WEBPACK FOOTER
 ** ./~/groupby-api/dist/src/models/request.js
 ** module id = 147
 ** module chunks = 0
 **/